import { FeatureRequestInfo } from './vo/feature-request-info.model';

/**
 * ログインユーザ区分
 *
 * @export KYMW1001UserType
 * @enum KYMW1001UserType
 */
export const enum KYMW1001UserType {
  /** 取引先(卸) */
  WHOLESALE = '取引先(卸)',
  /** 企画支援 */
  PLANNING_SUPPORT = '企画支援',
}

/**
 * 特集商品提案状況確認（CXデザイン部用）画面の値を管理するクラス
 *
 * @export KYMW7003Model
 * @class KYMW7003Model
 */
export class KYMW7003Model {
  // 特集商品提案状況一覧
  public featureRequestList: FeatureRequestInfo[] = [];

  // ユーザ区分
  userType: string = '';

  // 取引先コード
  payeeSupplierCode: string = '';

  // 関連会社ID
  associatedCompanyId: string = '';
}